import style from './errorForm.module.scss';
import { useTranslation } from 'react-i18next';

const ErrorForm = () => {
  const { t } = useTranslation();

  return (
    <div className={style.content}>
      <div className={style.info}>
        <h2 className={style.info__title}>{t('errorForm.title')}</h2>
        <span className={style.info__describe}>{t('errorForm.action')}</span>
      </div>
    </div>
  );
};

export default ErrorForm;
